<template>
  <div class="biddingresult">
    <div class="biddingresult-box">
      <div class="biddingresult-header">
        <div class="biddingresult-center">
          <div class="biddingresult-title"><i class="title-decorate iconfont icon-decorate" />{{ $t('bidmanagementpur.biddingresult.biddingresult') }}</div>
          <div class="biddingresult-round-tab">{{ onlySupSign === 'Y' ? $t('bidmanagementpur.biddingresult.supSign') : $t('bidmanagementpur.biddingresult.supMore') }}</div>
        </div>
      </div>
      <HeaderInfo :data="detail" />
    </div>

    <div class="biddingresult-box">
      <div class="biddingresult-header">
        <div class="biddingresult-title"><i class="title-decorate iconfont icon-decorate" />{{ $t('bidmanagementpur.biddingresult.biddingDetail') }}</div>
      </div>
      <el-scrollbar>
        <StripeTable
          :[tableProp]="table"
          :hide-head="false"
          :list="list"
          style="padding: 0;"
        />
      </el-scrollbar>
    </div>
  </div>
</template>

<script>
import http from '@/plugin/axios'
import HeaderInfo from './resultsrelease/components/header-info'
import Table from '@utils/table'
import StripeTable from '@/components/table/stripe-table/stripe-table'
const table = new Table('bidmanagementpur.biddingresult')
  .type('index')
  .add('goodsType')
  .add('number')
  .add('name')
  .add('model')
  .add('category')
  .add('technologyName')
  .add('unit')
  .add('currencyName')
  .add('qty')
  .add('fixedPrice')
  .add('giveUpSign')
  .add('goodsPrice')
  .add('taxRate')
  .add('taxIncludedAmount')
  .add('remarks')
  .add('purchaseStandard')
  .add('expectedDeliveryDate')

export default {
  components: {
    HeaderInfo,
    StripeTable
  },
  data() {
    return {
      detail: {}
    }
  },
  computed: {
    onlySupSign() {
      return this.detail.onlySupSign
    },
    list() {
      return this.detail.recordList || []
    },
    tableProp() {
      return '$table'
    },
    table() {
      return table
    }
  },
  async created() {
    const detail = await http({
      url: '/srmBiddingRecord/getWinSupDetail',
      baseURL: process.env.VUE_APP_PURCHASE_API,
      data: { biddingHeadId: this.$route.params.id },
      loading: false
    })
    this.detail = detail
  }
}
</script>

<style lang="scss" scoped>
.biddingresult {
  &-box {
    position: relative;
    padding: 12px;
    background: #fff;
    margin-bottom: 12px;
  }
  &-white {
    padding: 12px;
    background: #fff;
  }

  &-header {
    display: flex;
    align-content: center;
    justify-content: space-between;
  }

  &-center {
    display: inline-flex;
    align-items: center;
  }

  &-title {
    display: inline-flex;
    align-items: center;
    color: #757575;
    font-size: 13px;
    font-weight: 700;
    line-height: 20px;
    .title-decorate {
      transform: scale(.7);
      color: #008EE3;
      margin-right: 2px;
    }
  }
  &-round-tab {
    margin-left: 15px;
    background-color: #E7F6FF;
    height: 32px;
    line-height: 32px;
    padding: 0 10px;
    border-radius: 4px;
    color: #008ee3;
    font-size: 12px;
  }

}
</style>
